export default __webpack_public_path__ + "static/media/iso_image.d8184fca.jpg";